import { DeliveryInformationPaymentInformation } from '@common/interfaces';

export const defaultPaymentInformation: DeliveryInformationPaymentInformation = {
  orderStatus: '',
  is3DSPayment: false,
  paymentMethod: 'CD',
  beforePaymentOrder: {
    data: {
      orderId: 'ABCDEFG1234',
      orderStatus: 'ticketed',
    },
  },
  warnings: [],
};

export const testPaymentInformationPaymentTicketed: DeliveryInformationPaymentInformation = {
  ...defaultPaymentInformation,
  orderStatus: 'ticketed',
  beforePaymentOrder: {
    data: {
      orderId: 'ABCDEFG1234',
      orderStatus: 'ticketed',
    },
  },
};

export const testPaymentInformationPaymentUnticketed: DeliveryInformationPaymentInformation = {
  ...defaultPaymentInformation,
  orderStatus: 'unticketed',
  beforePaymentOrder: {
    data: {
      orderId: 'ABCDEFG1234',
      orderStatus: 'unticketed',
    },
  },
};

export const testPaymentInformationPaymentUnpurchased: DeliveryInformationPaymentInformation = {
  ...defaultPaymentInformation,
  orderStatus: 'unpurchased',
  beforePaymentOrder: {
    data: {
      orderId: 'ABCDEFG1234',
      orderStatus: 'unpurchased',
    },
  },
};

export const testPaymentInformationPaymentAcceptedCv: DeliveryInformationPaymentInformation = {
  ...defaultPaymentInformation,
  paymentMethod: 'CV',
  orderStatus: 'paymentAccepted',
  beforePaymentOrder: {
    data: {
      orderId: 'ABCDEFG1234',
      orderStatus: 'paymentAccepted',
    },
  },
};

export const testPaymentInformationPaymentAcceptedIb: DeliveryInformationPaymentInformation = {
  ...defaultPaymentInformation,
  orderStatus: 'paymentAccepted',
  paymentMethod: 'IB',
  beforePaymentOrder: {
    data: {
      orderId: 'ABCDEFG1234',
      orderStatus: 'paymentAccepted',
    },
  },
};
